import React, { useRef, useEffect, useState, useImperativeHandle } from 'react';
import { UseSurveyFormatReturn, UseFormatViewReturn } from '../types';

export default function useFormatView<T extends HTMLElement = HTMLElement>(
  name: string,
  context: UseSurveyFormatReturn,
  forwardedRef?: React.Ref<T>
): UseFormatViewReturn<T> {
  const { active, register, unregister } = context;

  const ref = useRef<T>(null);
  useImperativeHandle(forwardedRef, () => (ref?.current as T) || {});

  const [isActive, setIsActive] = useState(false);
  useEffect(() => setIsActive(active?.ref === ref), [active, ref]);

  React.useEffect(() => {
    register(name, ref);
    return () => unregister(name);
  }, [name, ref, register, unregister]);

  return { ref, isActive };
}
